import { render, staticRenderFns } from "./PythonDownload.vue?vue&type=template&id=694904df&scoped=true&"
import script from "./PythonDownload.vue?vue&type=script&lang=js&"
export * from "./PythonDownload.vue?vue&type=script&lang=js&"
import style0 from "./PythonDownload.vue?vue&type=style&index=0&id=694904df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694904df",
  null
  
)

export default component.exports